import React, { useState, useEffect, useContext } from "react";

// FIREBASE
import {
  addDoc,
  collection,
  doc,
  getDocs,
  limit,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../../config/firebase-config";

// FUNCTIONS
import { firebaseUpdateSchedulesDb } from "../../../../functions/firebaseUpdateSchedulesdb";
import { AllDataUsers } from "../../../../context/AllDataUsers";
import { formatDate } from "../../../../functions/formatDate";

export default function AddPlayeurModal({
  uid,
  usersRegisted,
  numberOfPlaces,
  level,
  setShowModal1,
}) {
  const [formData, setFormData] = useState({
    nameEnter: "",
    email: "",
    phone: "",
    birthDay: "",
  });
  console.log(formData);
  

  const { nameEnter, email, phone, birthDay } = formData;

  const [priority, setPriority] = useState(false);

  const { usersData } = useContext(AllDataUsers);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowModal1(false);
    const dataForExcel = {
      birthDay: birthDay,
      phone: phone,
      email: email,
    };
    if (nameEnter.trim() !== "" && usersRegisted.length < numberOfPlaces) {
      await firebaseUpdateSchedulesDb(
        uid,
        nameEnter,
        "arrayUnion",
        dataForExcel
      );
      const infoPlayeurAdd = {
        name: nameEnter.trim().toLowerCase(),
        email: email,
        phone: phone,
        level: level,
        birthDay: birthDay,
        dateInscription: new Date(),
        isPayed: false,
      };

      const info = usersData.filter(
        (user) => user.name == nameEnter.trim().toLowerCase()
      );
      if (!priority) {
        // Recherche du document existant
        const q = query(
          collection(db, "users"),
          where("playeurNames", "array-contains", infoPlayeurAdd.name)
        );

        const querySnapshot = await getDocs(q);

        // SI LE DOCUMENT EXISTE → UPDATE
        if (!querySnapshot.empty) {
          const existingDoc = querySnapshot.docs[0];

          await updateDoc(doc(db, "users", existingDoc.id), {
            playeurInfo: [infoPlayeurAdd],
            playeurNames: [infoPlayeurAdd.name],
          });

        }

        // SINON → CREATE
        else {
          await addDoc(collection(db, "users"), {
            playeurInfo: [infoPlayeurAdd],
            playeurNames: [infoPlayeurAdd.name],
          });
        }
      }
    }
  };

  // Ajoutez ces états dans votre composant
  const [suggestions, setSuggestions] = useState([]);

  const handleInputChange = (e) => {
    const { value, name } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Recherche uniquement sur le champ nom
    if (name === "nameEnter") {
      if (value.length > 2) {
        fetchSuggestions(value.toLowerCase().trim());
      } else {
        setSuggestions([]);
      }
    }
  };

  // Fonction pour récupérer les suggestions
  const fetchSuggestions = async (input) => {
    const usersRef = collection(db, "excel-users");
    const q = query(
      usersRef,
      where("name", ">=", input),
      where("name", "<=", input + "\uf8ff"),
      limit(4)
    );
    const querySnapshot = await getDocs(q);
    const fetchedSuggestions = [];
    querySnapshot.forEach((doc) => {
      const { name, birthDay, email, phone } = doc.data();
      fetchedSuggestions.push({ name, birthDay, email, phone }); // Ajoutez ces propriétés à l'array
    });
    setSuggestions(fetchedSuggestions);
  };

  // Ajoutez un useEffect pour nettoyer les suggestions lors de la fermeture du modal ou un autre événement
  useEffect(() => {
    return () => {
      setSuggestions([]);
    };
  }, []);

  

  const formatDateFR = (date) => {
    if (!date) return "";

    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };
  return (
    <div className="confirmation-modal-container">
      <form
        className="card responsive-card"
        style={{ width: "35%" }}
        onSubmit={handleSubmit}
      >
        <h1
          className="title"
          style={{ color: "var(--background-color)", margin: "10px 0" }}
        >
          Ajouter un joueur
        </h1>
        <div
          className="inputs"
          style={{ width: "90%", display: "flex", flexDirection: "column" }}
        >
          <input
            style={{ width: "100%" }}
            type="text"
            name="nameEnter"
            onChange={handleInputChange}
            value={nameEnter}
            placeholder="Nom et prénom"
          />

          <input
            style={{ width: "100%" }}
            type="text"
            name="birthDay"
            onChange={handleInputChange}
            value={birthDay}
            placeholder="Date de naissance"
          />

          <input
            style={{ width: "100%" }}
            type="text"
            name="email"
            onChange={handleInputChange}
            value={email}
            placeholder="Email"
          />

          <input
            style={{ width: "100%" }}
            type="tel"
            name="phone"
            onChange={handleInputChange}
            value={phone}
            placeholder="Téléphone"
            maxLength="10"
          />
          <label htmlFor="priority">Priorité adulte</label>
          <input
            type="checkbox"
            name="priority"
            onChange={() => setPriority(!priority)}
          />
        </div>
        {suggestions.length > 0 && (
          <ul style={{ cursor: "pointer" }}>
            {suggestions.map((suggestion, index) => (
              <li
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    nameEnter: suggestion.name,
                    birthDay: formatDateFR(suggestion.birthDay),
                    email: suggestion.email,
                    phone: suggestion.phone,
                  }));
                  // setFormData(suggestion.birthDay.slice(0, 4));
                }}
                key={index}
              >
                {suggestion.name}
              </li>
            ))}
          </ul>
        )}
        <div className="buttons">
          <button
            type="button"
            className="cancel-button"
            onClick={() => setShowModal1(false)}
          >
            Annuler
          </button>
          <button type="submit" className="confirm-button">
            Valider
          </button>
        </div>
      </form>
    </div>
  );
}
